import { render, staticRenderFns } from "./ticketsOrganizationList.vue?vue&type=template&id=32c56d7a&scoped=true"
import script from "./ticketsOrganizationList.vue?vue&type=script&lang=js"
export * from "./ticketsOrganizationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c56d7a",
  null
  
)

export default component.exports